import colors from "../colors";
import ramp from "../ramp";

export var scheme = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(colors);

export default ramp(scheme);



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/sequential-multi/YlOrRd.js
// module id = SHo5
// module chunks = 0